export default __webpack_public_path__ + "static/media/ticTacToeSample.039d1a519be06a7410b92230ed9ecf7f.png";